import $ from 'jquery'

$(document).ready(function () {
  $('.js-story-preview').addClass('animate')
  $('.js-story').on('click', function (e) {
    e.preventDefault()
    var $story = $(e.currentTarget)
    if (!$story.hasClass('active') && $story.find('.story__teaser')) {
      $('.js-story-preview').removeClass('animate')
      setTimeout(function () {
        $story.siblings().removeClass('active').end().addClass('active')
        var preview = $story.find('.story__teaser').html()
        $('.js-story-preview')
          .html(preview ? preview : null)
          .delay(300)
          .queue(function () {
            $(this).addClass('animate').dequeue()
          })
      }, 300)
    }
  })
})
